import * as React from "react";
import { Button } from "azure-devops-ui/Button";

export default class BasicTooltipExample extends React.Component {
    public render(): JSX.Element {
        return (
            <div style={{ margin: "8px" }}>
                <Button
                    iconProps={{ iconName: "Add" }}
                    text="This button has a tooltip"
                    tooltipProps={{ text: "Tooltip content" }}
                />
            </div>
        );
    }
}
